import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'quoteandbind.PerProduct.wizard.step.Coverables',
        defaultMessage: 'Coverables',
    },
    questions: {
        id: 'quoteandbind.PerProduct.wizard.step.Questions',
        defaultMessage: 'Questions',
    },
    stepCoverages: {
        id: 'quoteandbind.PerProduct.wizard.step.Coverages',
        defaultMessage: 'Coverages',
    },
    exposures: {
        id: 'quoteandbind.PerProduct.wizard.step.Exposures',
        defaultMessage: 'Exposures',
    },
    // add string ids and default values for localization here
});
